import { render, staticRenderFns } from "./parents.vue?vue&type=template&id=87dbbda2&"
import script from "./parents.vue?vue&type=script&lang=js&"
export * from "./parents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports